import { baseApi } from '@/services/api'

import { Tracker } from '@/features/trackers/types'

const apiWithTags = baseApi.enhanceEndpoints({})

interface GetTrackersQueryArgs {
  params?: string;
  page?: number;
}

export const trackersApi = apiWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getTrackers: builder.query<{ items: Tracker[] }, GetTrackersQueryArgs>({
      query: ({ params, page }) => {
        const searchParams = new URLSearchParams(params).toString()

        return `trackers${searchParams ? `?${searchParams}&page=${page}` : `?page=${page}`}`
      },
      providesTags: ['Trackers'],
    }),
    generateReports: builder.mutation({
      query: data => ({
        url: 'reports/generate',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const {
  useGetTrackersQuery,
  useGenerateReportsMutation,
} = trackersApi
